import { useCallback } from 'react';
import { ShippingLineConfig } from '../../../types';
import { REACT_APP_API_BASE_URL } from '../../env';
import { useProtectedRoute } from './useProtectedRoute';

export default function useShippingLineConfigApiRoutes() {
  const protectedRoute = useProtectedRoute();

  const getShippingLineConfigs = useCallback(async (): Promise<{
    shippingLineConfigs: ShippingLineConfig[];
    defaultBcc: string;
  }> => {
    const response = await protectedRoute({
      method: 'get',
      url: `${REACT_APP_API_BASE_URL}/shipping-line-configs`,
    });
    return {
      shippingLineConfigs: response?.shippingLineConfigs ?? [],
      defaultBcc: response?.defaultBcc ?? '',
    };
  }, [protectedRoute]);

  const upsertShippingLineConfig = useCallback(
    async (shippingLineCode: string, config: Partial<ShippingLineConfig>): Promise<ShippingLineConfig> => {
      const response = await protectedRoute({
        method: 'put',
        url: `${REACT_APP_API_BASE_URL}/shipping-line-configs/${shippingLineCode}`,
        data: config,
      });
      return response;
    },
    [protectedRoute]
  );

  return { getShippingLineConfigs, upsertShippingLineConfig };
}
